/* Perry Spices top bar rotator (Oct 9).
   Splits the top bar text (Theme settings > Top bar > Text 2) on "•" and shows one message at a time. */
(function(){
  function init(){
    var p = document.querySelector('.dt-sc-header-top-bar .top-bar-text2');
    if (!p || p.dataset.psRot) return;
    var items = p.textContent.split('•').map(function(s){ return s.trim(); }).filter(Boolean);
    if (items.length < 2) return;
    p.dataset.psRot = '1';
    p.classList.add('ps-rot-on');
    p.setAttribute('aria-label', items.join(', '));
    p.innerHTML = '';
    var wrap = document.createElement('span'); wrap.className = 'ps-rot';
    var prev = document.createElement('button'); prev.type = 'button'; prev.className = 'ps-rot__btn'; prev.setAttribute('aria-label', 'Previous message'); prev.textContent = '<';
    var msg = document.createElement('span'); msg.className = 'ps-rot__msg'; msg.setAttribute('aria-live', 'off');
    var next = document.createElement('button'); next.type = 'button'; next.className = 'ps-rot__btn'; next.setAttribute('aria-label', 'Next message'); next.textContent = '>';
    wrap.appendChild(prev); wrap.appendChild(msg); wrap.appendChild(next); p.appendChild(wrap);
    var i = 0, timer = null, still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n){
      i = (n + items.length) % items.length;
      if (still){ msg.textContent = items[i]; return; }
      msg.classList.add('is-out');
      setTimeout(function(){ msg.textContent = items[i]; msg.classList.remove('is-out'); }, 250);
    }
    function start(){ stop(); timer = setInterval(function(){ show(i + 1); }, 3500); }
    function stop(){ if (timer) clearInterval(timer); timer = null; }
    msg.textContent = items[0];
    prev.addEventListener('click', function(){ show(i - 1); start(); });
    next.addEventListener('click', function(){ show(i + 1); start(); });
    wrap.addEventListener('mouseenter', stop);
    wrap.addEventListener('mouseleave', start);
    start();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
